import {
  getActionDescription,
  getActionLabel,
  MODULE_REGISTRY,
  SupportedModule,
} from '../../moduleRegistry'

type ActionSelectorProps = {
  module: SupportedModule
  onSelectAction: (action: string) => void
}

export default function ActionSelector({
  module,
  onSelectAction,
}: ActionSelectorProps) {
  const moduleConfig = MODULE_REGISTRY[module]
  const actions = Object.keys(moduleConfig.actions)

  const gridCols =
    actions.length === 2 ? 'sm:grid-cols-2' : 'sm:grid-cols-2 lg:grid-cols-3'

  return (
    <div className='space-y-4'>
      <div className='space-y-2'>
        <h2 className='text-foreground text-lg font-semibold'>
          {moduleConfig.label} Module
        </h2>
        <p className='text-muted-foreground text-sm'>
          Select an action to perform
        </p>
      </div>

      <div className={`grid gap-3 ${gridCols}`}>
        {actions.map(action => (
          <button
            key={action}
            type='button'
            onClick={() => onSelectAction(action)}
            className='border-border bg-card hover:border-primary/40 text-card-foreground flex flex-col items-start gap-2 rounded-lg border p-4 text-left transition-colors'
          >
            <div className='text-foreground font-semibold'>
              {getActionLabel(module, action)}
            </div>
            <p className='text-muted-foreground text-sm'>
              {getActionDescription(module, action)}
            </p>
          </button>
        ))}
      </div>
    </div>
  )
}
